import * as Persona from 'persona'
import * as React from 'react'
import { IDVStatus } from '../../../../utilities/steps'
import * as actions from '../../../../actions'
import { connect } from 'react-redux'
import { IDV_CONTACT_SUPPORT_URL } from '../../../../constants'
import Loading from '@doordash/component-loading'

type Props = {
  uniqueLink?: string
  vehicleType?: string
  trackIdentityVerificationSteps: (data: any) => any
  onUpdate?: any
  updateIdvStatus?: (
    uniqueLink: string,
    inquiryId: string,
    event: string,
  ) => Promise<any>,
  idvStatus?: {
    value?: string
  },
  renderToggle: boolean
}

export const TemplateIdTypes = {
  'motorized': 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
  'non-motorized': 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff'
}

export const TemplateIds = {
  'car': 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
  'scooter': 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
  'motorcycle': 'tmpl_kfaFkGugqG9jqh6aAuc21Vwd',
  'bicycle': 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
  'walking': 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
  'other': 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
}

const determineTemplateId = (vehicleType: string) => {
  return TemplateIds[vehicleType]
}

type PersonaEvent =
  | 'load'
  | 'start'
  | 'country-select'
  | 'document-camera-select'
  | 'document-camera-capture'
  | 'document-upload'
  | 'verification-select'
  | 'verification-change'
  | 'success'
  | 'fail'
  | 'exit'
  | 'selfie-camera-select'
  | 'selfie-camera-capture'

const IdentityVerification: React.FC<Props> = ({
  uniqueLink,
  vehicleType,
  onUpdate,
  trackIdentityVerificationSteps,
  updateIdvStatus,
  idvStatus,
  renderToggle
}) => {

  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {

    setIsLoading(true)

    const client = new Persona.Client({
      templateId: determineTemplateId(vehicleType),
      environment: 'production',
      referenceId: uniqueLink,
      onLoad: () => {
        setIsLoading(false)
        client.open()
      },
      onStart: async (inquiryId: string) => {
        await updateIdvStatus(uniqueLink, inquiryId, 'start')
      },
      onComplete: async (inquiryId: string, scopes) => {
        await updateIdvStatus(uniqueLink, inquiryId, 'complete')
        onUpdate({ idVerificationStatus: IDVStatus.COMPLETED })
      },
      onFail: async (inquiryId: string) => {
        window.open(IDV_CONTACT_SUPPORT_URL, '_blank')
        await updateIdvStatus(uniqueLink, inquiryId, 'fail')
        onUpdate({ idVerificationStatus: IDVStatus.FAILED})
      },
      onExit: (error, metadata) => {
        onUpdate({ idVerificationStatus: IDVStatus.NOT_COMPLETED, renderToggle: !renderToggle })
      },
      onEvent: (eventName: PersonaEvent, metadata: any) => {
        trackIdentityVerificationSteps({
          status: metadata && metadata.status,
          step: eventName,
        })
      },
    })
  }, [renderToggle])

  if (isLoading) {
    return <Loading />
  }

  return null
}

const mapStateToProps = state => ({
  idvStatus: state.idvStatus,
})

const mapDispatchToProps = {
  updateIdvStatus: actions.updateIdvStatus,
}
export default connect(mapStateToProps, mapDispatchToProps)(IdentityVerification)


